export default class Queue {
  constructor(items = []) {
    this.items = items;
  }

  enqueue(...elements) {
    this.items.push(...elements);
  }

  dequeue() {
    if (!this.isEmpty()) return this.items.shift();
  }

  front() {
    if (!this.isEmpty()) return this.items[0];
  }

  isEmpty() {
    return this.items.length == 0;
  }

  size() {
    return this.items.length;
  }
}